<template>
  <div id="business-edit-tab-general">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">{{ $t('users.information') }}</span>
        </div>

        <!-- Col Content -->
        <div>
          <vs-input
            class="w-full mt-4"
            :label="$t('businesses.website')"
            v-model="dataLocal.website"
            name="website"
          />
          <span class="text-danger text-sm" v-show="errors.has('website')">{{
            errors.first('website')
          }}</span>

          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('businesses.plans.plan') }}</label>
            <v-select
              v-model="planLocal"
              :clearable="false"
              :options="planOptions"
              v-validate="'required'"
              name="plan"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('plan')">{{ errors.first('plan') }}</span>
          </div>

          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('entity.state') }}</label>
            <v-select
              v-model="stateLocal"
              :clearable="false"
              :options="stateOptions"
              v-validate="'required'"
              name="state"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('state')">{{ errors.first('state') }}</span>
          </div>

          <!--Expiration Date -->
          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('businesses.expiration_date') }}</label>

            <date-picker type="datetime" v-model="dataLocal.expirationDate" element="expirationDate" />
            <vs-input
              name="expirationDate"
              id="expirationDate"
              :value="
                $moment(dataLocal.expirationDate)
                  .locale($vs.rtl ? 'fa' : 'en')
                  .format('HH:mm dddd, DD MMMM YYYY')
              "
              v-validate="'required'"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('expirationDate')">{{
              errors.first('expirationDate')
            }}</span>
          </div>
        </div>
      </div>

      <!-- Connections -->
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end md:mt-0 mt-base">
          <feather-icon icon="UsersIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">{{ $t('entity.connections') }}</span>
        </div>

        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" :label="$t('entity.groups')" v-model="groups" name="groups" />
          <span class="text-danger text-sm" v-show="errors.has('groups')">{{ errors.first('groups') }}</span>

          <vs-input class="w-full mt-4" :label="$t('entity.tags')" v-model="tags" name="tags" />
          <span class="text-danger text-sm" v-show="errors.has('tags')">{{ errors.first('tags') }}</span>

          <vs-input class="w-full mt-4" :label="$t('entity.partners')" v-model="partners" name="partners" />
          <span class="text-danger text-sm" v-show="errors.has('partners')">{{
            errors.first('partners')
          }}</span>
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
            $t('forms.update')
          }}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="resetData">{{
            $t('forms.reset')
          }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      avatar: null
    }
  },
  computed: {
    stateOptions() {
      return this.$store.getters['enum/selectOptions']('State', 'entity.states')
    },
    stateLocal: {
      get() {
        return {
          label: this.$t(`entity.states.${this.dataLocal.state}`),
          value: this.dataLocal.state
        }
      },
      set(obj) {
        this.dataLocal.state = obj.value
      }
    },
    planOptions() {
      return this.$store.getters['enum/selectOptions']('BusinessPlan', 'businesses.plans')
    },
    planLocal: {
      get() {
        return { label: this.$t(`businesses.plans.${this.dataLocal.plan}`), value: this.dataLocal.plan }
      },
      set(obj) {
        this.dataLocal.plan = obj.value
      }
    },
    validateForm() {
      return !this.errors.any()
    },
    groups: {
      get() {
        return this.dataLocal.groups.join(', ')
      },
      set(value) {
        this.dataLocal.groups = value.split(',').map(attr => attr.trim())
      }
    },
    tags: {
      get() {
        return this.dataLocal.tags.join(', ')
      },
      set(value) {
        this.dataLocal.tags = value.split(',').map(attr => attr.trim())
      }
    },
    partners: {
      get() {
        return this.dataLocal.partners.join(', ')
      },
      set(value) {
        this.dataLocal.partners = value.split(',').map(attr => attr.trim())
      }
    }
  },
  methods: {
    saveChanges() {
      if (!this.validateForm) return
      this.$store
        .dispatch('business/editBusiness', { id: this.dataLocal.id, data: this.dataLocal })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$store.dispatch('business/editBusinessState', { id: res.data.id, state: this.dataLocal.state })
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_edited')
          })
        })
    },
    resetData() {
      this.dataLocal = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>
